/**
 * 악덕알리미 설정 BS — 체불번호감지(call-block) / 통화이력공유(call-share).
 *
 * 사용 (설정 허브 → BS 전용. 단독 페이지 없음):
 *   $j.F.Devil.Settings.openCallBlock()
 *   $j.F.Devil.Settings.openCallShare()
 *
 * 목록/검색/탭/토글 로직 + 두 cfg(체불번호감지·통화이력공유)를 본 파일에서 자체 구현(유일 구현).
 *
 * cfg 구조:
 *   listUrl, toggleUrl, idField, stateField, idParam, stateParam,
 *   tabs: [{key,label}], tabOf(item)→key, matches(item,kw)→bool, rowHtml(item)→html,
 *   title, infoHtml, searchPlaceholder
 */
function shellHtml(cfg){
    const tabsHtml = cfg.tabs.map((t, i) => `
        <button class="b-pill ${i===0?'is-on':''}" data-tab="${t.key}">
            ${esc(t.label)} <span data-cnt="${t.key}">0</span>
        </button>`).join('');
    return `
        <div class="b-cfg">
            <details class="b-card b-cfg__info">${cfg.infoHtml}</details>
            <!-- 2026-09-14 기획 — 체불 리스트 검색창과 같게: × + 오른쪽 검색 버튼, 버튼·Enter 로만 검색 -->
            <div class="b-card b-cfg__search">
                <input id="b-cfg-q" class="b-search" placeholder="${esc(cfg.searchPlaceholder)}" autocomplete="off" enterkeyhint="search">
                <button type="button" id="b-cfg-reset" class="b-search-reset" aria-label="검색 초기화" hidden><i class="fas fa-times"></i></button>
                <button type="button" id="b-cfg-go" class="b-search-go" aria-label="검색">
                    <svg width="17" height="17" viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="5.5" stroke="var(--on-brand)" stroke-width="1.6"/><path d="M11 11l3.5 3.5" stroke="var(--on-brand)" stroke-width="1.6" stroke-linecap="round"/></svg>
                </button>
            </div>
            <!-- 탭은 내용 폭대로 두고 줄이 넘치면 가로 스크롤 + 힌트(리스트·내제보건 알약 줄과 동일). 3등분 고정폭은 "허용안함 3" 이
                 아주크게에서 "허용…" 으로 잘려 "허용 2" 와 구분이 안 됐다(2026-09-12 QA) -->
            <div class="b-cfg__tabs b-noscroll" data-scroll-fade>${tabsHtml}</div>
            <div id="b-cfg-list" class="b-cfg__list"></div>
            <div id="b-cfg-status" class="b-cfg__status"></div>
        </div>`;
}

function buildTarget(cfg){
    const state = { items: [], tab: cfg.tabs[0].key, keyword: '' };

    return {
        init() {
            const $cont = $('#' + this.id);
            $cont.html(shellHtml(cfg));
            $j.Ui.ScrollFade.attachAll($cont[0]);   // JS 로 그린 [data-scroll-fade] 는 직접 부착
            this.parent.setTitle(cfg.title);

            const $list   = $cont.find('#b-cfg-list');
            const $status = $cont.find('#b-cfg-status');
            const $q      = $cont.find('#b-cfg-q');
            const $reset  = $cont.find('#b-cfg-reset');

            // 검색 — 버튼·Enter 로만 적용(체불 리스트와 같게). input 은 × 노출 토글에만
            const syncReset = () => $reset.prop('hidden', !$q.val().length);
            const search = () => { state.keyword = $q.val().trim().toLowerCase(); render(); };
            $q.on('input.cfgBS', syncReset);
            $q.on('keydown.cfgBS', (e) => { if (e.key === 'Enter') { e.preventDefault(); search(); } });
            $cont.on('click.cfgBS', '#b-cfg-go', search);
            $reset.on('click.cfgBS', () => {
                $q.val('').focus();
                syncReset();
                if (state.keyword !== '') { state.keyword = ''; render(); }
            });

            // 탭 클릭
            $cont.on('click.cfgBS', '.b-cfg__tabs .b-pill', function(){
                state.tab = $(this).data('tab');
                $cont.find('.b-cfg__tabs .b-pill').removeClass('is-on');
                $(this).addClass('is-on');
                render();
            });

            // 토글 클릭 (위임)
            $list.on('click.cfgBS', '.b-toggle', function(){ onToggle($(this)); });

            load();

            function load(){
                $status.text('불러오는 중…');
                $.getJSON(cfg.listUrl)
                    .done(res => {
                        if (!res || !res.result) { $status.text('불러오기 실패'); return; }
                        state.items = res.data || [];
                        updateCounts();
                        render();
                    })
                    .fail(() => $status.text('불러오기 실패'));
            }

            function updateCounts(){
                const cnt = { all: state.items.length };
                cfg.tabs.forEach(t => { if (t.key !== 'all') cnt[t.key] = 0; });
                state.items.forEach(it => {
                    const k = cfg.tabOf(it);
                    if (cnt[k] !== undefined) cnt[k]++;
                });
                Object.keys(cnt).forEach(k => $cont.find(`[data-cnt="${k}"]`).text(cnt[k]));
            }

            function render(){
                const filtered = state.items.filter(it => {
                    if (state.tab !== 'all' && cfg.tabOf(it) !== state.tab) return false;
                    if (state.keyword && !cfg.matches(it, state.keyword)) return false;
                    return true;
                });
                if (!filtered.length) {
                    $list.empty();
                    $status.text(state.keyword ? '검색 결과가 없습니다.' : '항목이 없습니다.');
                    return;
                }
                $status.text('');
                $list.html(filtered.map(it => cfg.rowHtml(it)).join(''));
            }

            function onToggle($tg){
                const id = $tg.data('id');
                const it = state.items.find(x => x[cfg.idField] === id);
                if (!it) return;
                const next = !it[cfg.stateField];
                it[cfg.stateField] = next;
                updateCounts();
                render();
                // 앱 로컬 즉시 동기화 (setMasterPref) — 서버 POST 와 별개. detect/share 중 하나만.
                if (cfg.brokerField && it.master_num) {
                    const pref = { masterNum: it.master_num };
                    pref[cfg.brokerField] = next; // detect=allowed, share=shared (next 와 동일 극성)
                    $j.F.Devil.App.setMasterPref(pref);
                }
                const payload = {};
                payload[cfg.idParam]    = id;
                payload[cfg.stateParam] = next ? 1 : 0;
                $.post(cfg.toggleUrl, payload).fail(() => {
                    it[cfg.stateField] = !next;
                    updateCounts();
                    render();
                    alert('설정 변경에 실패했습니다.');
                });
            }
        },
        destroy() {
            // BS 가 content-area 를 비워주므로 별도 cleanup 없음
        }
    };
}

// ── 체불번호감지 (CallBlock 과 동일 cfg) ──
const CALL_BLOCK_CFG = {
    title:    '체불번호감지설정',
    searchPlaceholder: '업체명 또는 전화번호 검색',
    listUrl:    '/b/ajax/settings/blocks',
    toggleUrl:  '/b/ajax/settings/block',
    idField:    'master_num',
    stateField: 'allowed',
    idParam:    'master_num',
    stateParam: 'allowed',
    brokerField: 'detect',   // setMasterPref: 감지(allowed 와 동일 극성)
    tabs: [{key:'all', label:'전체'}, {key:'allow', label:'허용'}, {key:'deny', label:'허용안함'}],
    tabOf:   it => (it.allowed ? 'allow' : 'deny'),
    matches: (it, kw) => ((it.co_name || '') + (it.phone || '')).toLowerCase().includes(kw),
    rowHtml: it => {
        const amt = $j.F.Devil.Render.won(it.amount);   // 숫자+단위 한 덩어리(.u-nowrap)
        return `
            <div class="b-card b-cfgrow ${it.allowed ? 'is-on' : ''}">
                <div class="b-cfgrow__top">
                    <span class="b-cfgrow__co">${esc(it.co_name)}</span>
                    <span class="b-cfgrow__amt">${amt}</span>
                </div>
                <p class="b-cfgrow__phone">${esc(it.phone)}</p>
                <div class="b-cfgrow__foot">
                    <span class="b-cfgrow__state ${it.allowed ? 't-r' : ''}">${it.allowed ? '허용' : '허용안함'}</span>
                    <button type="button" class="b-toggle ${it.allowed ? 'is-on' : 'is-off'}" data-id="${it.master_num}"><span class="b-toggle__knob"></span></button>
                </div>
            </div>`;
    },
    infoHtml: `
        <summary><span class="b-cfg__info-i b-cfg__info-i--r">i</span>체불번호감지란?</summary>
        <div class="b-cfg__info-body">
            <p>• 악덕알리미에 등록된 <b class="t-r">체불업체(자)의 전화가 감지</b>되면 경고 팝업을 표시합니다.</p>
            <p><b>허용</b> — 체불업체에서 전화가 오면 경고 팝업이 뜸</p>
            <p><b>허용안함</b> — 경고 팝업이 나타나지 않음</p>
        </div>`,
};

// ── 통화이력공유 (CallShare 와 동일 cfg) ──
const CALL_SHARE_CFG = {
    title:    '통화이력공유설정',
    searchPlaceholder: '업체명 또는 전화번호 검색',
    listUrl:    '/b/ajax/settings/calls',
    toggleUrl:  '/b/ajax/settings/share',
    idField:    'master_num',
    stateField: 'shared',
    idParam:    'master_num',
    stateParam: 'shared',
    brokerField: 'share',    // setMasterPref: 통화이력공유(shared 와 동일 극성)
    tabs: [{key:'all', label:'전체'}, {key:'share', label:'공유'}, {key:'hide', label:'공유안함'}],
    tabOf:   it => (it.shared ? 'share' : 'hide'),
    matches: (it, kw) => ((it.co_name || '') + (it.phone || '')).toLowerCase().includes(kw),
    rowHtml: it => {
        const amt = $j.F.Devil.Render.won(it.amount);   // 숫자+단위 한 덩어리(.u-nowrap)
        return `
            <div class="b-card b-cfgrow ${it.shared ? 'is-on-c' : ''}">
                <div class="b-cfgrow__top">
                    <span class="b-cfgrow__co">${esc(it.co_name)}</span>
                    <span class="b-cfgrow__amt">${amt}</span>
                </div>
                <p class="b-cfgrow__phone">${esc(it.phone)} · ${esc(it.time)}</p>
                <div class="b-cfgrow__foot">
                    <span class="b-cfgrow__state ${it.shared ? 't-c' : ''}">${it.shared ? '공유' : '공유안함'}</span>
                    <button type="button" class="b-toggle b-toggle--c ${it.shared ? 'is-on' : 'is-off'}" data-id="${it.master_num}"><span class="b-toggle__knob"></span></button>
                </div>
            </div>`;
    },
    infoHtml: `
        <summary><span class="b-cfg__info-i b-cfg__info-i--c">i</span>통화이력 공유란?</summary>
        <div class="b-cfg__info-body">
            <p>• 체불업체와의 <b class="t-c">통화이력을 체불 피해자에게 공유</b>해 회수에 도움을 줍니다.</p>
            <p>• 통화이력은 <b class="t-c">피해자에게만</b> 공유되며 일반에는 공개되지 않습니다.</p>
            <p><b>공유</b> — 피해자에게 통화이력 공유 / <b>공유안함</b> — 공유되지 않음</p>
        </div>`,
};

function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

export default class Settings {
    openCallBlock = () => {
        $j.Ui.BS.open({ target: buildTarget(CALL_BLOCK_CFG), fixedHeight: true, backClose: true });
    }
    openCallShare = () => {
        $j.Ui.BS.open({ target: buildTarget(CALL_SHARE_CFG), fixedHeight: true, backClose: true });
    }
}
